export const DeathCertifiers = [
    { value: 'Doctor', label: 'Doctor' },
    { value: 'TribalChief', label: 'Tribal Chief' },
    { value: 'Induna', label: 'Induna' },
];
